
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bddW2", function(module, exports) {

$parcel$export(module.exports, "P", () => $829bb7da611c6214$export$56c0d5a1e737357d);
$parcel$export(module.exports, "match", () => $829bb7da611c6214$export$4659b591c19bdf3d);
const $829bb7da611c6214$var$t = Symbol.for("@ts-pattern/matcher"), $829bb7da611c6214$var$e = Symbol.for("@ts-pattern/isVariadic"), $829bb7da611c6214$var$n = "@ts-pattern/anonymous-select-key", $829bb7da611c6214$var$r = (t)=>Boolean(t && "object" == typeof t), $829bb7da611c6214$var$i = (e)=>e && !!e[$829bb7da611c6214$var$t], $829bb7da611c6214$var$s = (n, o, c)=>{
    if ($829bb7da611c6214$var$i(n)) {
        const e = n[$829bb7da611c6214$var$t](), { matched: r, selections: i } = e.match(o);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($829bb7da611c6214$var$r(n)) {
        if (!$829bb7da611c6214$var$r(o)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(o)) return !1;
            let t = [], r = [], a = [];
            for (const s of n.keys()){
                const o = n[s];
                $829bb7da611c6214$var$i(o) && o[$829bb7da611c6214$var$e] ? a.push(o) : a.length ? r.push(o) : t.push(o);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (o.length < t.length + r.length) return !1;
                const e = o.slice(0, t.length), n = 0 === r.length ? [] : o.slice(-r.length), i = o.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$829bb7da611c6214$var$s(t, e[n], c)) && r.every((t, e)=>$829bb7da611c6214$var$s(t, n[e], c)) && (0 === a.length || $829bb7da611c6214$var$s(a[0], i, c));
            }
            return n.length === o.length && n.every((t, e)=>$829bb7da611c6214$var$s(t, o[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in o || $829bb7da611c6214$var$i(a = r) && "optional" === a[$829bb7da611c6214$var$t]().matcherType) && $829bb7da611c6214$var$s(r, o[e], c);
        });
    }
    return Object.is(o, n);
}, $829bb7da611c6214$var$o = (e)=>{
    var n, s, a;
    return $829bb7da611c6214$var$r(e) ? $829bb7da611c6214$var$i(e) ? null != (n = null == (s = (a = e[$829bb7da611c6214$var$t]()).getSelectionKeys) ? void 0 : s.call(a)) ? n : [] : Array.isArray(e) ? $829bb7da611c6214$var$c(e, $829bb7da611c6214$var$o) : $829bb7da611c6214$var$c(Object.values(e), $829bb7da611c6214$var$o) : [];
}, $829bb7da611c6214$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $829bb7da611c6214$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$829bb7da611c6214$var$s(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $829bb7da611c6214$var$s(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $829bb7da611c6214$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$829bb7da611c6214$var$h(t),
        and: (e)=>$829bb7da611c6214$var$m(t, e),
        or: (e)=>$829bb7da611c6214$var$d(t, e),
        select: (e)=>void 0 === e ? $829bb7da611c6214$var$y(t) : $829bb7da611c6214$var$y(e, t)
    });
}
function $829bb7da611c6214$var$l(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$829bb7da611c6214$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$829bb7da611c6214$var$l($829bb7da611c6214$var$h(t)),
        select: (e)=>$829bb7da611c6214$var$l(void 0 === e ? $829bb7da611c6214$var$y(t) : $829bb7da611c6214$var$y(e, t))
    });
}
function $829bb7da611c6214$var$h(e) {
    return $829bb7da611c6214$var$u({
        [$829bb7da611c6214$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($829bb7da611c6214$var$o(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $829bb7da611c6214$var$s(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$829bb7da611c6214$var$o(e),
                matcherType: "optional"
            })
    });
}
const $829bb7da611c6214$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $829bb7da611c6214$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $829bb7da611c6214$var$m(...e) {
    return $829bb7da611c6214$var$u({
        [$829bb7da611c6214$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$829bb7da611c6214$var$s(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$829bb7da611c6214$var$c(e, $829bb7da611c6214$var$o),
                matcherType: "and"
            })
    });
}
function $829bb7da611c6214$var$d(...e) {
    return $829bb7da611c6214$var$u({
        [$829bb7da611c6214$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $829bb7da611c6214$var$c(e, $829bb7da611c6214$var$o).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$829bb7da611c6214$var$s(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$829bb7da611c6214$var$c(e, $829bb7da611c6214$var$o),
                matcherType: "or"
            })
    });
}
function $829bb7da611c6214$var$p(e) {
    return {
        [$829bb7da611c6214$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $829bb7da611c6214$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $829bb7da611c6214$var$u({
        [$829bb7da611c6214$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $829bb7da611c6214$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $829bb7da611c6214$var$s(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $829bb7da611c6214$var$n
                    ].concat(void 0 === i ? [] : $829bb7da611c6214$var$o(i))
            })
    });
}
function $829bb7da611c6214$var$v(t) {
    return "number" == typeof t;
}
function $829bb7da611c6214$var$b(t) {
    return "string" == typeof t;
}
function $829bb7da611c6214$var$w(t) {
    return "bigint" == typeof t;
}
const $829bb7da611c6214$var$S = $829bb7da611c6214$var$u($829bb7da611c6214$var$p(function(t) {
    return !0;
})), $829bb7da611c6214$var$O = $829bb7da611c6214$var$S, $829bb7da611c6214$var$j = (t)=>Object.assign($829bb7da611c6214$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, (n = e, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, (n = e, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$b(e) && e.length >= t))(e))),
        length: (e)=>$829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, (n = e, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $829bb7da611c6214$var$j($829bb7da611c6214$var$m(t, (n = e, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$b(t) && Boolean(t.match(n))))));
        }
    }), $829bb7da611c6214$var$K = $829bb7da611c6214$var$j($829bb7da611c6214$var$p($829bb7da611c6214$var$b)), $829bb7da611c6214$var$x = (t)=>Object.assign($829bb7da611c6214$var$u(t), {
        between: (e, n)=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, ((t, e)=>$829bb7da611c6214$var$p((n)=>$829bb7da611c6214$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$v(e) && e < t))(e))),
        gt: (e)=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$v(e) && e > t))(e))),
        lte: (e)=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$v(e) && e <= t))(e))),
        gte: (e)=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$v(e) && e >= t))(e))),
        int: ()=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$v(t) && t > 0))),
        negative: ()=>$829bb7da611c6214$var$x($829bb7da611c6214$var$m(t, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$v(t) && t < 0)))
    }), $829bb7da611c6214$var$E = $829bb7da611c6214$var$x($829bb7da611c6214$var$p($829bb7da611c6214$var$v)), $829bb7da611c6214$var$A = (t)=>Object.assign($829bb7da611c6214$var$u(t), {
        between: (e, n)=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, ((t, e)=>$829bb7da611c6214$var$p((n)=>$829bb7da611c6214$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$w(e) && e < t))(e))),
        gt: (e)=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$w(e) && e > t))(e))),
        lte: (e)=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$w(e) && e <= t))(e))),
        gte: (e)=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, ((t)=>$829bb7da611c6214$var$p((e)=>$829bb7da611c6214$var$w(e) && e >= t))(e))),
        positive: ()=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$w(t) && t > 0))),
        negative: ()=>$829bb7da611c6214$var$A($829bb7da611c6214$var$m(t, $829bb7da611c6214$var$p((t)=>$829bb7da611c6214$var$w(t) && t < 0)))
    }), $829bb7da611c6214$var$P = $829bb7da611c6214$var$A($829bb7da611c6214$var$p($829bb7da611c6214$var$w)), $829bb7da611c6214$var$T = $829bb7da611c6214$var$u($829bb7da611c6214$var$p(function(t) {
    return "boolean" == typeof t;
})), $829bb7da611c6214$var$B = $829bb7da611c6214$var$u($829bb7da611c6214$var$p(function(t) {
    return "symbol" == typeof t;
})), $829bb7da611c6214$var$_ = $829bb7da611c6214$var$u($829bb7da611c6214$var$p(function(t) {
    return null == t;
})), $829bb7da611c6214$var$k = $829bb7da611c6214$var$u($829bb7da611c6214$var$p(function(t) {
    return null != t;
}));
var $829bb7da611c6214$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $829bb7da611c6214$var$t,
    optional: $829bb7da611c6214$var$h,
    array: function(...e) {
        return $829bb7da611c6214$var$l({
            [$829bb7da611c6214$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $829bb7da611c6214$var$o(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$829bb7da611c6214$var$s(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $829bb7da611c6214$var$o(e[0])
                })
        });
    },
    set: function(...e) {
        return $829bb7da611c6214$var$u({
            [$829bb7da611c6214$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $829bb7da611c6214$var$f(t, (t)=>$829bb7da611c6214$var$s(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $829bb7da611c6214$var$o(e[0])
                })
        });
    },
    map: function(...e) {
        return $829bb7da611c6214$var$u({
            [$829bb7da611c6214$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [o, c] = e;
                        return {
                            matched: $829bb7da611c6214$var$g(t, (t, e)=>{
                                const n = $829bb7da611c6214$var$s(o, e, r), i = $829bb7da611c6214$var$s(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$829bb7da611c6214$var$o(e[0]),
                            ...$829bb7da611c6214$var$o(e[1])
                        ]
                })
        });
    },
    intersection: $829bb7da611c6214$var$m,
    union: $829bb7da611c6214$var$d,
    not: function(e) {
        return $829bb7da611c6214$var$u({
            [$829bb7da611c6214$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$829bb7da611c6214$var$s(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $829bb7da611c6214$var$p,
    select: $829bb7da611c6214$var$y,
    any: $829bb7da611c6214$var$S,
    _: $829bb7da611c6214$var$O,
    string: $829bb7da611c6214$var$K,
    number: $829bb7da611c6214$var$E,
    bigint: $829bb7da611c6214$var$P,
    boolean: $829bb7da611c6214$var$T,
    symbol: $829bb7da611c6214$var$B,
    nullish: $829bb7da611c6214$var$_,
    nonNullable: $829bb7da611c6214$var$k,
    instanceOf: function(t) {
        return $829bb7da611c6214$var$u($829bb7da611c6214$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $829bb7da611c6214$var$u($829bb7da611c6214$var$p($829bb7da611c6214$export$ce1e7a33533a73d9(t)));
    }
};
class $829bb7da611c6214$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $829bb7da611c6214$var$$ = {
    matched: !1,
    value: void 0
};
function $829bb7da611c6214$export$4659b591c19bdf3d(t) {
    return new $829bb7da611c6214$var$I(t, $829bb7da611c6214$var$$);
}
class $829bb7da611c6214$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let o = !1, c = {};
        const a = (t, e)=>{
            o = !0, c[t] = e;
        }, u = !r.some((t)=>$829bb7da611c6214$var$s(t, this.input, a)) || i && !Boolean(i(this.input)) ? $829bb7da611c6214$var$$ : {
            matched: !0,
            value: e(o ? $829bb7da611c6214$var$n in c ? c[$829bb7da611c6214$var$n] : c : this.input, this.input)
        };
        return new $829bb7da611c6214$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $829bb7da611c6214$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $829bb7da611c6214$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive() {
        if (this.state.matched) return this.state.value;
        throw new $829bb7da611c6214$export$6c1467edb54d3773(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}

});


//# sourceMappingURL=EndOfPageRecommendation.ccd2be62.js.map
